module.exports = __webpack_public_path__ + "img/video_poster.7fd00843.jpg";